import { lccstore } from '@holmescorp/lcc-state';
import { XAPI } from '@holmescorp/xapi';
import { TopicItem } from 'lcc-state/interfaces';

interface TopicInfo {
	association: string;
	product: string;
	topicKey: string;
}

// XAPI CALLS
const recordLoad = (details: TopicInfo) => {
	const { association, product, topicKey } = details;
	const target = new XAPI.Activity({ id: topicKey });
	const verb = XAPI.Verbs.EXPERIENCED;
	const context = new XAPI.Context({
		extensions: { 'urn:holmes:reading:topic': `${association}-${product}-${topicKey}` }
	});
	const actor = lccstore.get(lccstore.path('actor_xapi'));

	const statement = new XAPI.Statement({ actor, target, context, verb }).asVersion();

	return XAPI.svc.set_statement({ stmnt: statement });
};

const recordProgress = (details: TopicInfo, progress: number) => {
	const { association, product, topicKey } = details;
	const target = new XAPI.Activity({ id: topicKey });
	const result = new XAPI.Result({
		extensions: { 'http://w3id.org/xapi/cmi5/result/extensions/progress': progress }
	});
	const verb = XAPI.Verbs.PROGRESSED;
	const context = new XAPI.Context({
		extensions: { 'urn:holmes:reading:topic': `${association}-${product}-${topicKey}` }
	});
	const actor = lccstore.get(lccstore.path('actor_xapi'));

	const statement = new XAPI.Statement({ actor, target, verb, context, result }).asVersion();

	return XAPI.svc.set_statement({ stmnt: statement });
};

const recordCompleted = (details: TopicInfo) => {
	const { association, product, topicKey } = details;
	const target = new XAPI.Activity({ id: topicKey });
	const result = new XAPI.Result({
		succcess: true,
		completion: true
	});
	const verb = XAPI.Verbs.COMPLETED;
	const context = new XAPI.Context({
		extensions: { 'urn:holmes:reading:topic': `${association}-${product}-${topicKey}` }
	});
	const actor = lccstore.get(lccstore.path('actor_xapi'));

	const statement = new XAPI.Statement({ actor, target, verb, context, result }).asVersion();

	return XAPI.svc.set_statement({ stmnt: statement });
};

// PUBLIC HANDLERS
export const handleReadingLoaded = async (topics: TopicItem[]) => {
	const { association = '', product = '' } = window.hcstatic;
	const topicsLoaded = [];
	for (const topic in topics) {
		const topicKey = topics[topic].topic.attributes.key || topics[topic].topic.attributes.id || '';
		const info = { association, product, topicKey };
		topicsLoaded.push(recordLoad(info));
	}

	await Promise.all(topicsLoaded);
};

export const isDoneReading = () => {
	const amountViewed = window.innerHeight + window.scrollY;
	const total = document.body.offsetHeight;
	const percentViewed = Math.round((amountViewed / total) * 100);

	return percentViewed === 100;
};

export const handleReadingCompleted = async (topics: TopicItem[]) => {
	const { association = '', product = '' } = window.hcstatic;
	const topicsCompleted = [];
	for (const topic in topics) {
		const topicKey = topics[topic].topic.attributes.key || topics[topic].topic.attributes.id || '';
		const info = { association, product, topicKey };
		topicsCompleted.push(recordProgress(info, 100));
		topicsCompleted.push(recordCompleted(info));
	}

	await Promise.all(topicsCompleted);
};
